import React from 'react';
import styled from 'styled-components';

import { Command, tabActions } from '@store/slices';
import { Label } from '@common/Label';
import { useDispatch } from 'react-redux';
import { NodeField } from '@components/Flow/Nodes';
import { JSONEditor } from '@common/JSONEditor/JSONEditor';
import { useNodeData } from '@common/hooks/useNodeData';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
`;

interface Props {
  command: Command;
  field: NodeField;
  enabled: boolean;
  nodeValue: string;
}

export const SchemaEditor: React.FC<Props> = ({ command, field, enabled, nodeValue }) => {
  const dispatch = useDispatch();

  const { id, label, description } = field;
  const { getOptions, dataEdges } = useNodeData(command?.node?.id);

  const dataOptions = getOptions(command.node.id);

  const updateValue = (value: string) => {
    const nodeId = command.node.id;
    const fieldId = id;

    dispatch(tabActions.nodeInputUpdate({ nodeId, fieldId, fieldName: 'value', value }));
    dispatch(tabActions.setSaved(false));
  };

  if (!enabled) return null;
  return (
    <Container>
      <Label title={label} tooltip={description} />
      <JSONEditor value={nodeValue || ''} setValue={updateValue} options={dataOptions} dataEdges={dataEdges} />
    </Container>
  );
};
